import { Box, Checkbox, Table } from "@mantine/core";

import { IconTestPipe } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import { LAB_TABLE_COLUMNS } from "../constants/tables";
import { LabsTableProps } from "../interfaces/encounter-table";

import { EmptyStateTable } from "./EmptyStateTable";

export function LabsTable({ items, onItemChange }: LabsTableProps) {
  if (items.length === 0) {
    return (
      <EmptyStateTable
        columns={LAB_TABLE_COLUMNS}
        message="There are currently no labs for this client."
        icon={<IconTestPipe size={18} color="var(--mantine-color-gray-6)" />}
      />
    );
  }

  return (
    <Box
      style={{
        overflow: "hidden",
        borderRadius: "var(--mantine-radius-md)",
        border: "1px solid var(--mantine-color-cream-4)",
      }}
    >
      <Table withRowBorders verticalSpacing="md" borderColor="cream.4" horizontalSpacing="md">
        <Table.Thead bg="cream.3">
          <Table.Tr>
            {LAB_TABLE_COLUMNS.map((column) => (
              <Table.Th key={column}>
                <TextWrapper c="dark.9" variant="bold">
                  {column}
                </TextWrapper>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {items.map(({ key, checked, labDate, labName }, index) => (
            <Table.Tr key={key}>
              <Table.Td>
                <Checkbox
                  label={labDate}
                  checked={checked}
                  onChange={(event) => onItemChange(index, event.currentTarget.checked)}
                />
              </Table.Td>
              <Table.Td>
                <TextWrapper>{labName ?? "-"}</TextWrapper>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
}
